import React from 'react';
import { NotificationCountSC } from './notification-count.styled';

type TProps = {
  count?: number | string;
  className?: string;
};

const NotificationCount: React.FC<TProps> = ({ count, className }) => {
  if (count) {
    return <NotificationCountSC className={className}>{count}</NotificationCountSC>;
  }
  return null;
};

export default NotificationCount;
